module.exports = __webpack_public_path__ + "3f335bac63d1a3480169a176df237776.svg";


//////////////////
// WEBPACK FOOTER
// ../statics/assets/svg/chamoso-super-happy-green.svg
// module id = 2404
// module chunks = 1